import DriverContractsListResponse, {
  DriverContractsListResponseData,
  DriverContractsListResponseDataModel,
} from "../../../../api/raily/driver/contracts/list/driver-contracts-list.response";
import BillingModel from "../../../../types/billing-model";
import DriverContractsList, {
  DriverContractsListData,
} from "./driver-contracts-list";

const createDataItemModel = (
  model: DriverContractsListResponseDataModel,
): BillingModel => {
  switch (model) {
    case DriverContractsListResponseDataModel.AB:
      return BillingModel.AB;
    case DriverContractsListResponseDataModel.ABA:
      return BillingModel.ABA;
    case DriverContractsListResponseDataModel.OTHER:
      return BillingModel.OTHER;
    case DriverContractsListResponseDataModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItem = (
  item: DriverContractsListResponseData,
): DriverContractsListData => {
  return {
    active: item.active,
    companyName: item.companyName,
    contractId: item.contractId,
    distanceRate: item.distanceRate,
    haltingTimeAfterMinutes: item.haltingTimeAfterMinutes,
    haltingTimeRate: item.haltingTimeRate,
    model: createDataItemModel(item.model),
    validSince: item.validSince,
    validTo: item.validTo,
  };
};

const createData = (
  data: DriverContractsListResponseData[],
): DriverContractsListData[] => {
  return data.map(createDataItem);
};

const create = (response: DriverContractsListResponse): DriverContractsList => {
  return createData(response.data);
};

const driverContractsListFactory = {
  create,
};

export default driverContractsListFactory;
